import { Outlet } from 'react-router';

export function ProjectsLayout() {
  return <Outlet />;
}
